import { createComponent } from '@lib/util/templateHelpers';

export default createComponent('Content', {}, function Content ({ className, style }, props) {
  return (
    <div className={className} style={style}>
      {props.children}
    </div>
  );
});
